// ==================== Imports ====================
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Button } from 'react-bootstrap';
import axios from 'axios';
import ProductAdd from './Dashboard/Productadd';
import Userpage from './Dashboard/Userpage';

const API_ORIGIN = window.APP_CONFIG.API_URL.replace(/\/$/, '');

// ==================== Dashboard Component ====================
export default function Dashboard() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [userProducts, setUserProducts] = useState([]);

  const navigate = useNavigate();
  const userEmail = localStorage.getItem('user');

  // ==================== Check login ====================
  useEffect(() => {
    if (!userEmail) {
      navigate('/login');
      return;
    }

    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ORIGIN}/hello`);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        await response.json();
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [navigate, userEmail]);

  // ==================== Fetch user's products ====================
  useEffect(() => {
    if (!userEmail) return;

    const loadProducts = async () => {
      try {
        const res = await axios.get(`${API_ORIGIN}/products?email=${userEmail}`);
        setUserProducts(res.data.products || []);
      } catch { }
    };

    loadProducts();
  }, [userEmail]);

  // ==================== Loading / Error ====================
  if (loading) return <p style={styles.text}>🔄 Loading dashboard...</p>;
  if (error) return <p style={{ ...styles.text, color: 'red' }}>❌ Error: {error}</p>;

  // ==================== Render ====================
  return (
    <div style={styles.container}>

      {/* Dashboard Header */}
      <div
        style={{
          ...styles.header,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '20px'
        }}
      >

        {/* LEFT SIDE BUTTONS */}
        <div style={{ display: 'flex', gap: '15px' }}>
          <Button
            style={{ backgroundColor: '#702963', borderColor: '#702963' }}
            onClick={() => navigate('/requests')}
          >
            Requests Data
          </Button>

          <Button
            style={{ backgroundColor: '#702963', borderColor: '#702963' }}
            onClick={() => setShowModal(true)}
          >
            Add Product
          </Button>
        </div>

        {/* RIGHT SIDE – ICON STYLE MY ACCOUNT */}
        <div
          style={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: "10px",
            color: "white"
          }}
          onClick={() => navigate('/myaccount')}
        >
          {/* round icon */}
          <div
            style={{
              fontSize: "26px",
              backgroundColor: "white",
              color: "#4b0082",
              width: "45px",
              height: "45px",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0px 2px 6px rgba(0,0,0,0.2)"
            }}
          >
            👤
          </div>

          {/* text */}
          <span style={{ fontSize: "18px", fontWeight: "700", color: "#702963"}}>
            My Account
          </span>
        </div>

      </div>

      {/* Product Add Modal */}
      <ProductAdd
        show={showModal}
        handleClose={() => setShowModal(false)}
        userEmail={userEmail}
        onProductAdded={(newProduct) =>
          setUserProducts((prev) => [...prev, newProduct])
        }
      />

      {/* Marketplace Products */}
      <Userpage />
    </div>
  );
}

// ==================== Styles ====================
const styles = {
  container: {
    padding: '20px',
    fontFamily: 'Arial, sans-serif',
    minHeight: '100vh',
    backgroundColor: '#f8f9fa'
  },
  header: {
    textAlign: 'center',
    marginBottom: '30px',
    padding: '30px',
    background: '#FF7F50',
    color: 'white',
    borderRadius: '15px',
    boxShadow: '0 4px 15px rgba(0,0,0,0.1)'
  },
  text: {
    textAlign: 'center',
    marginTop: '50px',
    fontSize: '18px'
  }
};
